<script setup>
import { ref, computed, watch } from "vue";
import { formatPrice, applyDiscount } from "@app/helpers";
import { useBookingStore } from "@stores/BookingStore";

// Define Props
const props = defineProps({
  patient: Number,
  type: String,
  vaccination: {
    type: Array,
    required: false,
  },
  clinic: {
    type: Object,
    required: true,
  },
});

const bookingStore = useBookingStore();

// Computed Properties
const hasDiscount = computed(() => {
  return Number(props.clinic.booster_max_discount) > 0;
});

// Watch for course changes and update global preferences
watch(
  () => props.vaccination.course,
  (newCourse, oldCourse) => {
    if (newCourse !== oldCourse) {
      if (newCourse === 'full') {
        bookingStore.setCoursePreference(props.vaccination.id, 'full');
      } else if (newCourse === 'single') {
        bookingStore.removeCoursePreference(props.vaccination.id);
      }
    }
  }
);
</script>

<template>
  <tr>
    <td class="align-top" v-html="vaccination.name"></td>
    <td class="align-top">
      <div class="flex items-center gap-2">
        <input
          type="radio"
          value="single"
          v-model="vaccination.course"
          :name="`${type}_${patient}_${vaccination.name}`" />
        <span> £{{ vaccination.price }} </span>
      </div>
    </td>
    <td v-if="vaccination.dose > 1">
      <div class="flex max-sm:flex-col items-center gap-2">
        <div class="flex items-center gap-2">
          <input
            type="radio"
            value="full"
            v-model="vaccination.course"
            :name="`${type}_${patient}_${vaccination.name}`" />
          <span :class="{ 'line-through': hasDiscount }">
            £{{
              formatPrice(Number(vaccination.price) * Number(vaccination.dose))
            }}
          </span>

          <span v-if="hasDiscount" class="font-medium text-red-600">
            £{{
              formatPrice(
                applyDiscount(
                  Number(vaccination.price) * Number(vaccination.dose),
                  clinic.booster_max_discount
                )
              )
            }}
          </span>
        </div>

        <span class="text-12 text-grey/[0.5] whitespace-nowrap">
          (total of {{ vaccination.dose }} doses)
        </span>
      </div>
    </td>
  </tr>
</template>

<style scoped lang="scss"></style>
